import { DELETE_ICON_SVG } from '../../utils/icon-helper';

/**
 * Common DOM manipulation utilities for AST nodes.
 */
export class DomHelpers {
  /**
   * Creates a delete button element.
   */
  public static createDeleteButton(className: string): HTMLElement {
    const deleteButton = document.createElement('button');
    deleteButton.className = className;
    deleteButton.dataset['action'] = 'delete';
    deleteButton.setAttribute('contenteditable', 'false');
    deleteButton.type = 'button';
    deleteButton.ariaLabel = 'Excluir';
    deleteButton.innerHTML = DELETE_ICON_SVG;
    return deleteButton;
  }

  /**
   * Creates a tooltip element.
   */
  public static createTooltip(className: string, text: string): HTMLElement {
    const tooltip = document.createElement('span');
    tooltip.className = className;
    tooltip.textContent = text;
    return tooltip;
  }

  /**
   * Renders delete button HTML.
   */
  public static renderDeleteButtonHtml(className: string): string {
    const button = document.createElement('button');
    button.type = 'button';
    button.ariaLabel = 'Excluir';
    button.setAttribute('contenteditable', 'false');
    button.className = className;
    button.dataset['action'] = 'delete';
    button.innerHTML = DELETE_ICON_SVG;

    return button.outerHTML;
  }
}
